import React, { useState, useEffect } from "react";
import shortid from "shortid";
import { Link } from "react-router-dom";

import "../../assets/css/utility/input-field.css";
import "../../assets/css/utility/user-card.css";
import "../../assets/css/load-list-page.css";
import "../../assets/css/loads-list-search-page.css";
import LoaderImg from "../../assets/media/loader.gif";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {
  COUNTRY_STATE_N_CITY_LIST_URL,
  GET_LOAD_LIST_URL,
} from "../../utils/api-ends";

import useHttp from "../../hooks/useHttp";
import Rating from "../../components/Rating";

// Define initial values for loadPostValues
const INITIAL_LOAD_POST_VALUES = {
  country: "",
  state: "",
  city: "",
  rating: "",
  load_type: "",
  nextPageNumber: "",
};

const SearchLoadPost = () => {
  const [loadPostValues, setLoadPostValues] = useState(INITIAL_LOAD_POST_VALUES);
  const { isLoading, sendRequests } = useHttp();
  const { isLoading: isLoadingLoadPost, sendRequests: loadPostSendRequest } =
    useHttp();
  const [countryList, setCountryList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [loadPostList, setLoadPostList] = useState([]);

  const clearFilter = () => {
    // Reset loadPostValues to initial values
    setLoadPostValues(INITIAL_LOAD_POST_VALUES);
    // Optionally clear other states 
    setCountryList([]);
    setStateList([]);
    setCityList([]);
    // You may also want to refetch the initial load list here
    fetchInitialLoadList();
    fetchInitialCountryList()
  };


  // Fetch initial country list
  const fetchInitialCountryList = () => {
    const response = (data) => {
      setCountryList(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "countries",
        },
      },
      response
    );
  };

   // Logic to check if any filters are applied
   const isFilterApplied = () => {
    return Object.values(loadPostValues).some(value => value !== "" && value !== null);
  };

  const fetchInitialLoadList = () => {
    const response = (data) => {
      setLoadPostList(data.data.results);
      const inputValue = {
        ...INITIAL_LOAD_POST_VALUES,
        nextPageNumber: data.data.pagination.next_page_number,
      };
      setLoadPostValues(inputValue);
    };
    // Send request to get Load Feed list
    sendRequests(
      {
        url: GET_LOAD_LIST_URL(),
        method: "GET",
      },
      response
    );
  };

  useEffect(() => {
   fetchInitialLoadList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Fetch list of country
  useEffect(() => {
    const response = (data) => {
      setCountryList(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "countries",
        },
      },
      response
    );
  }, [sendRequests]);

  // Fetch list of state
  useEffect(() => {
    const response = (data) => {
      setStateList(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "states",
          country_name: loadPostValues.country,
        },
      },
      response
    );
  }, [loadPostValues.country, sendRequests]);

  // Fetch list of city
  useEffect(() => {
    const response = (data) => {
      setCityList(data);
    };
    sendRequests(
      {
        url: COUNTRY_STATE_N_CITY_LIST_URL,
        method: "GET",
        params: {
          data_type: "cities",
          country_name: loadPostValues.country,
          state_name: loadPostValues.state,
        },
      },
      response
    );
  }, [loadPostValues.country, loadPostValues.state, sendRequests]);

  //Update state values when input values change.
  const handleInputChange = (e) => {
    const inputValue = {
      ...loadPostValues,
      [e.target.name]: e.target.value === 'all' ? '' : e.target.value,
      nextPageNumber: 2,
    };
    setLoadPostValues(inputValue);
  };

  useEffect(() => {
    const response = (data) => {
      setLoadPostList(data.data.results);
    };

    sendRequests(
      {
        url: GET_LOAD_LIST_URL(
          loadPostValues.state,
          loadPostValues.city,
          loadPostValues.rating,
          loadPostValues.load_type
        ),
        method: "GET",
      },
      response
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    loadPostValues.state,
    loadPostValues.city,
    loadPostValues.rating,
    loadPostValues.load_type,
    sendRequests
  ]);

  //Scroll Pagination
  window.onscroll = function (ev) {
    //Check if scroll to the bottom
    if (
      window.innerHeight + window.scrollY >= document.body.offsetHeight &&
      loadPostValues.nextPageNumber
    ) {
      const response = (data) => {
        // Update the loadPostList state
        setLoadPostList([...loadPostList, ...data.data.results]);
        const pageNumber =
          data.data.pagination.next_page_number != null
            ? data.data.pagination.next_page_number
            : "";
        setLoadPostValues({ ...loadPostValues, nextPageNumber: pageNumber });
      };

      // Send get request to get Load Feed list
      loadPostSendRequest(
        {
          url: GET_LOAD_LIST_URL(
            loadPostValues.state,
            loadPostValues.city,
            loadPostValues.rating,
            loadPostValues.load_type,
            loadPostValues.nextPageNumber
          ),
          method: "GET",
        },
        response
      );
    }
  };

  return (
    <>
      <section className="search-options-load-list">
        <div className="container theme-section">
          <h1 className="section-tittle text-center"> Search Or Filter Loads </h1>
          <div className="row">
            <div className="col-xl-3 col-md-6">
              <div className="input-box-area" single-labe="true">
                <label> Country</label>
                <div>
                  <Select
                    label="Country"
                    name="country"
                    className="input-box-area-select-field mui-select-field-without-label"
                    id="country-input-field"
                    fullWidth
                    value={loadPostValues.country}
                    onChange={handleInputChange}>
                    {countryList?.map((country) => (
                      <MenuItem value={country} key={shortid.generate()}>
                        {country}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="input-box-area" single-labe="true">
                <label> State/Region</label>
                <div>
                  <Select
                    label="State"
                    name="state"
                    className="input-box-area-select-field mui-select-field-without-label"
                    id="state-input-field"
                    fullWidth
                    value={loadPostValues.state}
                    onChange={handleInputChange}>
                    {stateList?.map((state, index) => (
                      <MenuItem value={state} key={shortid.generate()}>
                        {state}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="input-box-area" single-labe="true">
                <label> City</label>
                <div>
                  <Select
                    label="City"
                    name="city"
                    className="input-box-area-select-field mui-select-field-without-label"
                    fullWidth
                    value={loadPostValues.city}
                    onChange={handleInputChange}>
                    {cityList?.map((state, index) => (
                      <MenuItem value={state} key={shortid.generate()}>
                        {state}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="input-box-area" single-labe="true">
                <label> Rating </label>
                <div>
                  <Select
                    label="Rating"
                    name="rating"
                    className="input-box-area-select-field mui-select-field-without-label"
                    fullWidth
                    value={loadPostValues.rating}
                    onChange={handleInputChange}>
                    <MenuItem value="asc">ASC (User Rating Ascending Order)</MenuItem>
                    <MenuItem value="dsc">DESC (User Rating Descending Order)</MenuItem>
                  </Select>
                </div>
              </div>
            </div>

            <div className="col-xl-3 col-md-6">
              <div className="input-box-area" single-labe="true">
                <label> Load types </label>
                <div>
                  <Select
                    label="Load type"
                    name="load_type"
                    className="input-box-area-select-field mui-select-field-without-label"
                    fullWidth
                    value={loadPostValues.load_type}
                    onChange={handleInputChange}>
                    <MenuItem value="all">All</MenuItem>
                    <MenuItem value="vehicle">Vehicle</MenuItem>
                    <MenuItem value="pallet">Pallet</MenuItem>
                    <MenuItem value="barrel">Barrel</MenuItem>
                    <MenuItem value="stones">Stones</MenuItem>
                    <MenuItem value="sand">Sand</MenuItem>
                    <MenuItem value="laterite">Laterite</MenuItem>
                  </Select>
                </div>
              </div>
            </div>
          </div>
          {isFilterApplied() && (
            <div className="multiple-btn">
              <button onClick={clearFilter} className="m-0">
                <i className="fa-solid fa-xmark"></i>
                Clear Filter
              </button>
            </div>
          )}
        </div>
      </section>

      <section id="load-list-users">
        <div className="container">
          <div className="row">
            {isLoading ? (
              <div className="loader d-flex justify-content-center mb-5 mt-5">
                <img style={{ width: "35px" }} src={LoaderImg} alt="" />
              </div>
            ) : (
              <>
                {loadPostList?.map((value, index) => (
                  <div className="col-xl-4 col-md-6" key={shortid.generate()}>
                    <div className="user-info-and-load-details-card">
                      <div className="loader-user-info mb-3">
                        <div className="loader-user-img">
                          <img src={value?.shipper_obj?.profile_picture} alt="" />
                        </div>

                        <div>
                          <h1 className="large-text">
                            {value?.shipper_obj?.name}
                          </h1>
                          <div className="user-rating">
                            <Rating
                              rating={value?.shipper_obj?.avg_review_rating}
                            />
                            <span>
                              (
                              {value?.shipper_obj?.avg_review_rating != null
                                ? value?.shipper_obj?.avg_review_rating
                                : 0}
                              )
                            </span>
                          </div>
                        </div>
                      </div>

                      <div className="user-extra-info">
                        <h1 className="large-text">
                          {" "}
                          Total Amount: $ {value.price_to_pay_carrier}{" "}
                        </h1>
                        <div className="user-extra-info-box">
                          <span>Origin:</span>
                          <span>{value.origin_address}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Destination:</span>
                          <span>{value.destination_address}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Pick Up Date:</span>
                          <span>{value.pickup_date}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Delivery Date:</span>
                          <span>{value.delivery_date}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Load Type:</span>
                          <span>{value.load_type}</span>
                        </div>
                        <div className="user-extra-info-box">
                          <span>Total Loads:</span>
                          <span>{value.total_loads}</span>
                        </div>
                      </div>

                      <div className="multiple-btn mt-3">
                        <Link to={`/load-post/details/${value.id}`}>
                          Review Load
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
          {isLoadingLoadPost && (
            <div className="loader d-flex justify-content-center mb-5 mt-5">
              <img style={{ width: "35px" }} src={LoaderImg} alt="" />
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default SearchLoadPost;
